export default "__VITE_PUBLIC_ASSET__238fe9f6__"